
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ErrorView = function ErrorView(props) {
  if(props.idError === 1){
    return _react["default"].createElement("div", null, "Compruebe si el navegador cuenta con los permisos necesarios", _react["default"].createElement("br", null), _react["default"].createElement("br", null), "Porfavor, recarge y vuelva a probar \uD83D\uDC4D");
  }
  return _react["default"].createElement("div", null, "Oh snap! Your browser failed to record your video.", _react["default"].createElement("br", null), _react["default"].createElement("br", null), "Please restart it and try again \uD83D\uDC4D");
};

var _default = ErrorView;
exports["default"] = _default;